import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Выберите любой вариант входа в личный кабинет обучающегося ниже и следуйте инструкции ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Отсканируйте этот QR-код через любое приложение для сканирования QR-кодов на устройстве ребёнка и перейдите по ссылке. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Перейдите по адресу ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" на устройстве ребёнка и введите указанные выше логин и пароль. Отметьте пункт ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" \"Я - обучающийся\". ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Завершить сеанс ")

import { computed } from "vue";

import { useAsync } from "@/use/useAsync";
import { useTokens } from "@/use/useTokens";
import { useSessions } from "@/use/useSessions";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
import UiAppbarBack from "@/plugins/ui/components/appbar/UiAppbarBack.vue";
import UiBtn from "@/components/ui/UiBtn.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiPlaceholder from "@/plugins/ui/components/placeholder/UiPlaceholder.vue";
import UiTextField from "@/components/ui/UiTextField.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiCaption from "@/plugins/ui/components/typography/UiCaption.vue";
import UiText from "@/plugins/ui/components/typography/UiText.vue";

import UiQrcode from "@/components/ui/UiQrcode.vue";

import AppSidebar from "@/components/AppSidebar.vue";
import { UiCell } from "@/plugins/ui/components/cell";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChildAuth',
  setup(__props) {

const { entrantScore, fetchEntrantScore } = useTokens();
useAsync(fetchEntrantScore, true);

const { lkSession, lkUserAgentFormatted, fetchLkSession, deleteLkSession } =
  useSessions();

const asyncDelete = useAsync(deleteLkSession);
useAsync(fetchLkSession, true);

const location = window.location;

const url = computed(() => {
  const credential = JSON.stringify([
    entrantScore.value.id,
    entrantScore.value.entrant_password,
    true,
  ]);

  return `${location.origin}/#/login?credential=${window.btoa(credential)}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, { title: "Авторизация ребёнка" }, {
        left: _withCtx(() => [
          _createVNode(UiAppbarBack, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        _: 1
      })
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      (_unref(entrantScore).default_entrant_password)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "Как пользоваться?" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiText, null, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "Авторизация по QR коду" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiCard, null, {
                  default: _withCtx(() => [
                    _createVNode(UiQrcode, {
                      width: 228,
                      value: _unref(url),
                      style: {"margin":"auto"}
                    }, null, 8, ["value"]),
                    _createVNode(UiCaption, {
                      level: "1",
                      style: {"text-align":"center","margin-top":"16px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(UiGroup, null, {
              header: _withCtx(() => [
                _createVNode(UiHeader, { title: "Авторизация по логину и паролю" })
              ]),
              default: _withCtx(() => [
                _createVNode(UiCard, null, {
                  default: _withCtx(() => [
                    _createVNode(UiTextField, {
                      modelValue: _unref(entrantScore).id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(entrantScore).id) = $event)),
                      label: "Логин",
                      readonly: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(UiTextField, {
                      modelValue: _unref(entrantScore).entrant_password,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(entrantScore).entrant_password) = $event)),
                      label: "Пароль",
                      readonly: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(UiCaption, {
                      level: "1",
                      style: {"text-align":"center","margin-top":"16px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _createElementVNode("b", null, _toDisplayString(_unref(location).host), 1),
                        _hoisted_4,
                        _hoisted_5,
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createBlock(UiPlaceholder, {
            key: 1,
            icon: "ExclamationCircle",
            title: "Пароль ребёнка изменен",
            description: "Пароль был изменен через личный кабинет. Для восстановления пароля обратитесь в центр поддержки"
          })),
      (_unref(lkSession))
        ? (_openBlock(), _createBlock(UiGroup, { key: 2 }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Активные сессии" })
            ]),
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(UiCell), {
                    title: _unref(lkUserAgentFormatted).os,
                    description: _unref(lkUserAgentFormatted).description,
                    multiline: "",
                    style: {"white-space":"pre"}
                  }, {
                    left: _withCtx(() => [
                      _createVNode(UiIcon, {
                        icon: "DeviceMobile",
                        size: 24
                      })
                    ]),
                    _: 1
                  }, 8, ["title", "description"]),
                  _createVNode(UiBtn, {
                    onClick: _unref(asyncDelete).execute,
                    loading: _unref(asyncDelete).isPending.value,
                    disabled: _unref(asyncDelete).isPending.value,
                    variant: "alert",
                    class: "mt-4",
                    stretched: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})